<template>
	<div class="advert-manage-container">
		<!-- 导出卡片 -->
		<el-card shadow="hover" style="margin-bottom: 10px">
			<div class="ladger-header-content">
				<div>
					<div class="ledger-header-title">资产盘点</div>
					<div>全面掌握资产盘点情况，提高资产管理效率</div>
				</div>
				<div>
					<el-button type="primary" icon="el-icon-plus" @click="add">新建盘点计划</el-button>
					<el-button icon="el-icon-download">导出</el-button>
				</div>
			</div>
		</el-card>
		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />
		<div class="table">
			<!-- 表格 -->
			<div class="table-item">
				<BaseTable :selection="false" :pagination="false" :loading="loading" :data="tableData1" :columns="columns1">
					<template slot="header">
						<div class="card-header">
							<div>最近盘点计划</div>
							<el-button type="text">查看全部</el-button>
						</div>
					</template>
				</BaseTable>
			</div>
			<div class="table-item">
				<BaseTable :selection="false" :pagination="false" :loading="loading" :data="tableData2" :columns="columns2">
					<template slot="header">
						<div class="card-header">
							<div>最近盘点任务</div>
							<el-button type="text">查看全部</el-button>
						</div>
					</template>
				</BaseTable>
			</div>
		</div>
		<AssetInventoryDialog :dialogVisible.sync="dialogVisible" />
	</div>
</template>

<script>
	import AssetInventoryDialog from '@/components/asset/assetInventoryDialog.vue';
	export default {
		name: 'AssetInventory',
		components: { AssetInventoryDialog },
		data() {
			return {
				assetStats: [
					{ label: '盘点计划数', value: 12, unit: '个', color: '#5B8FF9' },
					{ label: '盘点任务数', value: 48, unit: '个', color: '#61DDAA' },
					{ label: '待盘点资产', value: 256, unit: '个', color: '#F6BD16' },
					{ label: '已盘点资产', value: 1847, unit: '个', color: '#7262FD' },
					{ label: '异常资产', value: 23, unit: '个', color: '#FF9D4D' },
					{ label: '盘点完成率', value: 87.5, unit: '%', color: '#FF6E76' },
				],
				loading: false,
				dialogVisible: false,
				tableData1: [
					{
						planName: '2026年第一季度资产盘点',
						scope: '总部办公楼及附属设施',
						status: '进行中',
						progress: '65%',
					},
					{
						planName: '园区广告位专项盘点',
						scope: '园区全部广告位资源',
						status: '未开始',
						progress: '0%',
					},
					{
						planName: '设备类资产年度盘点',
						scope: '生产设备及辅助设备',
						status: '已完成',
						progress: '100%',
					},
					{
						planName: '仓储资产盘点',
						scope: '1-3号仓库库存资产',
						status: '进行中',
						progress: '40%',
					},
					{
						planName: '固定资产专项核查',
						scope: '固定资产（含办公家具）',
						status: '已暂停',
						progress: '20%',
					},
				],
				tableData2: [
					{
						taskCode: 'RW-2026-001',
						scope: '总部办公楼',
						shouldCheck: 120,
						checked: 100,
						normal: 92,
						over: 5,
						loss: 3,
						accuracy: '92%',
						owner: '张伟',
						status: '进行中',
						progress: '83%',
					},
					{
						taskCode: 'RW-2026-002',
						scope: '园区广告位',
						shouldCheck: 80,
						checked: 80,
						normal: 78,
						over: 1,
						loss: 1,
						accuracy: '97.5%',
						owner: '李强',
						status: '已完成',
						progress: '100%',
					},
					{
						taskCode: 'RW-2026-003',
						scope: '生产设备',
						shouldCheck: 200,
						checked: 120,
						normal: 110,
						over: 6,
						loss: 4,
						accuracy: '91.7%',
						owner: '王磊',
						status: '进行中',
						progress: '60%',
					},
					{
						taskCode: 'RW-2026-004',
						scope: '仓储资产',
						shouldCheck: 150,
						checked: 60,
						normal: 55,
						over: 3,
						loss: 2,
						accuracy: '91.7%',
						owner: '赵敏',
						status: '进行中',
						progress: '40%',
					},
					{
						taskCode: 'RW-2026-005',
						scope: '办公家具',
						shouldCheck: 90,
						checked: 0,
						normal: 0,
						over: 0,
						loss: 0,
						accuracy: '0%',
						owner: '陈晨',
						status: '未开始',
						progress: '0%',
					},
				],
				columns1: [
					{ prop: 'planName', label: '计划名称', width: 180 },
					{ prop: 'scope', label: '盘点范围', width: 200 },
					{ prop: 'status', label: '状态', width: 120 },
					{ prop: 'progress', label: '进度' },
				],
				columns2: [
					{ prop: 'taskCode', label: '任务编码', width: 180 },
					{ prop: 'scope', label: '盘点范围', width: 180 },
					{ prop: 'shouldCheck', label: '应盘', width: 100 },
					{ prop: 'checked', label: '已盘', width: 100 },
					{ prop: 'normal', label: '盘平', width: 100 },
					{ prop: 'over', label: '盘盈', width: 100 },
					{ prop: 'loss', label: '盘亏', width: 100 },
					{ prop: 'accuracy', label: '一致率', width: 100 },
					{ prop: 'owner', label: '负责人', width: 120 },
					{ prop: 'status', label: '状态', width: 120 },
					{ prop: 'progress', label: '进度' },
				],
			};
		},
		created() {},
		methods: {
			add() {
				this.dialogVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
	.ledger-header-title {
		width: 100%;
		font-weight: bold;
		margin-bottom: 5px;
	}
	.ladger-header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.table {
		gap: 5px;
		display: flex;
		justify-content: space-between;
	}

	.table-item {
		width: calc(50% - 5px);
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
